<!--
    描述：动态表单 字段类型处理 公共模块
    时间：2020-05-28
    Created by ws
-->
<template>
	<el-tooltip :disabled="showTooltip"
				:content="showContent"
				placement="bottom-end">
		<el-form-item :label="currentObj.title"
					  :label-width="labelWidth">
			<!-- formType标段类型 -->
			<!-- 1005001 数值型 -->
			<el-input v-if="currentObj.formType === '1005001'"
					  v-model="currentObj.value"
					  type="number"
					  placeholder="请输入"
					  :disabled="isDisabled || currentObj.isEditable === 0">
				<template slot="append"
						  v-if="currentObj.additional.suffix && currentObj.additional.suffix !== ''">
					<span>{{ currentObj.additional.suffix }}</span>
				</template>
			</el-input>

			<!-- 1005002 文本型 -->
			<el-input v-if="currentObj.formType === '1005002'"
					  v-model="currentObj.value"
					  placeholder="请输入"
					  :disabled="isDisabled || currentObj.isEditable === 0">
				<template slot="append"
						  v-if="currentObj.additional && currentObj.additional.suffix && currentObj.additional.suffix !== ''">
					<span>{{ currentObj.additional.suffix }}</span>
				</template>
			</el-input>

			<!-- 1005003 日期型 -->
			<el-date-picker v-if="currentObj.formType === '1005003'"
							v-model="currentObj.value"
							:disabled="isDisabled || currentObj.isEditable === 0"
							:type="currentObj.additional.dateType"
							format="yyyy 年 MM 月 dd 日"
							value-format="yyyy-MM-dd"
							placeholder="请选择日期">
			</el-date-picker>

			<!-- 1005004 文件型 -->
			<el-input v-if="currentObj.formType === '1005004'"
					  v-model="currentObj.value"></el-input>

			<!-- 1005005 文本（textarea） -->
			<el-input v-if="currentObj.formType === '1005005'"
					  type="textarea"
					  class="special-textarea"
					  :autosize="{ maxRows: 1}"
					  :disabled="isDisabled || currentObj.isEditable === 0"
					  placeholder="请输入内容"
					  v-model="currentObj.value">
			</el-input>

			<!-- 1005006 下拉选择型 -->
			<el-select v-if="currentObj.formType === '1005006'"
					   v-model="currentObj.value"
					   :disabled="isDisabled || currentObj.isEditable === 0"
					   placeholder="请选择">
				<el-option v-for="(item, index) in currentObj.additional.options"
						   :key="item.value + index"
						   :label="item.value"
						   :value="item.value">
				</el-option>
			</el-select>

			<!-- 1005007 系统码表型 -->
			<el-select v-if="currentObj.formType === '1005007'"
					   v-model="currentObj.value"
					   :disabled="isDisabled || currentObj.isEditable === 0"
					   placeholder="请选择">
				<el-option v-for="(item, index) in currentObj.options"
						   :key="item.value + index"
						   :label="item.sname"
						   :value="item.value">
				</el-option>
			</el-select>

			<!-- 1005008 级联下拉框类型 -->
			<el-cascader v-if="currentObj.formType === '1005008'"
						 v-model="curValueArr"
						 :options="currentObj.options"
						 :disabled="isDisabled || currentObj.isEditable === 0"
						 :props="{ label: 'sname' }"
						 placeholder="请选择"
						 @change="handleChange"></el-cascader>

			<!-- 1005009 多选下拉框码表 -->
			<el-select v-if="currentObj.formType === '1005009'"
					   multiple
					   v-model="curValueArr"
					   :disabled="isDisabled || currentObj.isEditable === 0"
					   collapse-tags
					   placeholder="请选择"
					   @change="handleChange($event, true)">
				<el-option v-for="(item, index) in currentObj.options"
						   :key="item.value + index"
						   :label="item.sname"
						   :value="item.value">
				</el-option>
			</el-select>
		</el-form-item>
	</el-tooltip>

</template>

<script>
export default {
	props: {
		// 当前字段对象
		currentObj: {
			type: Object,
			default: () => {
				return {}
			}
		},
		// 是否可编辑
		isDisabled: {
			type: Boolean,
			default: true
		},
		// label 宽度
		labelWidth: {
			type: String,
			default: '110px'
		}
	},
	data() {
		return {
			curValueArr: []
		}
	},
	created() {
		if (this.currentObj.formType === '1005008' || this.currentObj.formType === '1005009') {
			this.curValueArr = this.currentObj.value.split(',')
		}

		if (this.currentObj.formType === '1005009' && this.currentObj.title === '功能用途') {
			this.handleChange(this.curValueArr, true)
		}
		// console.log(this.currentObj)
	},
	methods: {
		// 级联下拉框 选择事件
		handleChange(arr, type) {
			this.currentObj.value = arr.join(',')

			if (type) {
				this.$emit('changeShow', this.curValueArr)
			}
		}
	},
	computed: {
		// 是否展示 tooltip
		showTooltip() {
			let isHidden = true
			switch (this.currentObj.title) {
				case '容积率':
					isHidden = false
					break
				case '建筑密度':
					isHidden = false
					break
				case '绿化率':
					isHidden = false
					break
				case '建筑高度':
					isHidden = false
					break
				case '计容面积':
					isHidden = false
					break
				default:
					isHidden = true
			}
			return isHidden
		},
		// 展示的 内容
		showContent() {
			let content = ''
			switch (this.currentObj.title) {
				case '容积率':
					content =
						'指建设项目建设用地范围内,地面以上各类建筑的建筑面积总和与建设项目土地使用权权属用地面积的比值。表达公式为:容积率=地上总建筑面积建设用地面积。'
					break
				case '建筑密度':
					content =
						'指建设项目建设用地范围内,所有建筑物底层占地面积与基地面积的比率(%)。'
					break
				case '绿化率':
					content =
						'指建设项目建设用地范围内,绿地面积占总建设用地面积的比率( % ).'
					break
				case '建筑高度':
					content =
						'指建筑物室外地坪标高至女儿墙顶点最外沿的高度。坡屋项应按建筑物室外地坪标高至屋檐和屋脊的平均高度计算。'
					break
				case '计容面积':
					content =
						'计容面积即小区内所有计算容积率的建筑面积之和，等于规划建筑用地面积*计算容积率。一般情况下，计容面积小于等于建筑面积'
					break
				default:
					content = ''
			}
			return content
		}
	}
}
</script>

<style scoped lang="less">
/deep/ .special-textarea {
	.el-textarea__inner {
		height: 40px !important;
	}
}

/deep/ .el-input-group__append,
.el-input-group__prepend {
	padding: 0 10px !important;
}
</style>
